import React from 'react';
import { Star, StarHalf } from 'lucide-react';
const testimonials = [{
  id: 1,
  quote: 'Necesitaba liquidez rápida para cerrar un trato y Brixen respondió a la velocidad que mi negocio exige.',
  author: 'Ricardo B.',
  initials: 'RB',
  business: 'Bienes Raíces',
  rating: 5
}, {
  id: 2,
  quote: 'Atención personalizada por WhatsApp, respondieron todas mis preguntas al instante. Servicio 10/10.',
  author: 'Isabel Q.',
  initials: 'IQ',
  business: 'Florería',
  rating: 5
}, {
  id: 3,
  quote: 'En menos de 24 horas tenía el capital en mi cuenta. Increíble rapidez.',
  author: 'Carlos M.',
  initials: 'CM',
  business: 'Restaurante',
  rating: 5
}, {
  id: 4,
  quote: 'Me ayudaron a conseguir financiamiento cuando los bancos me dijeron que no. Eternamente agradecido.',
  author: 'Miguel A.',
  initials: 'MA',
  business: 'Construcción',
  rating: 5
}, {
  id: 5,
  quote: 'El proceso fue súper sencillo, sin tanto papeleo como en los bancos tradicionales.',
  author: 'Ana P.',
  initials: 'AP',
  business: 'Tienda Online',
  rating: 4.5
}, {
  id: 6,
  quote: 'Gracias a Brixen pude comprar el equipo que necesitaba para expandir mi negocio.',
  author: 'José L.',
  initials: 'JL',
  business: 'Transporte',
  rating: 5
}, {
  id: 7,
  quote: 'Excelente servicio, me explicaron cada paso del proceso. Muy profesionales.',
  author: 'María R.',
  initials: 'MR',
  business: 'Salón de Belleza',
  rating: 5
}, {
  id: 8,
  quote: 'Conseguí $150,000 en línea de crédito con 0% de interés. No lo podía creer.',
  author: 'Fernando D.',
  initials: 'FD',
  business: 'E-commerce',
  rating: 4.5
}, {
  id: 9,
  quote: 'Ya es la tercera vez que trabajo con ellos. Siempre cumplen lo que prometen.',
  author: 'Laura S.',
  initials: 'LS',
  business: 'Clínica Dental',
  rating: 5
}, {
  id: 10,
  quote: 'Me dieron opciones que ningún banco me ofreció. Totalmente recomendados.',
  author: 'Roberto G.',
  initials: 'RG',
  business: 'Food Truck',
  rating: 5
}, {
  id: 11,
  quote: 'El mejor servicio de financiamiento que he usado. Rápido, transparente y confiable.',
  author: 'Patricia V.',
  initials: 'PV',
  business: 'Gimnasio',
  rating: 4.5
}, {
  id: 12,
  quote: 'Pude abrir mi segunda ubicación gracias al capital que me proporcionaron.',
  author: 'Diego H.',
  initials: 'DH',
  business: 'Panadería',
  rating: 5
}];
export function Testimonials() {
  // Duplicate array for infinite scroll effect
  const duplicatedTestimonials = [...testimonials, ...testimonials];
  return <section id="testimonials" className="py-10 bg-white overflow-hidden" data-id="element-391">
      <style data-id="element-392">
        {`
          @keyframes scroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(calc(-50% - 1rem)); }
          }
          .animate-scroll {
            animation: scroll 40s linear infinite;
          }
          .animate-scroll:hover {
            animation-play-state: paused;
          }
        `}
      </style>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-8" data-id="element-393">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center uppercase" data-id="element-394">
          Testimonios
        </h2>
        <p className="text-sm text-gray-500 text-center mt-2" data-id="element-395">
          Confiado por +5,000 Negocios
        </p>
      </div>

      <div className="relative w-full overflow-hidden pb-4" data-id="element-396">
        {/* Gradient masks for smooth fade on edges */}
        <div className="absolute left-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" data-id="element-397"></div>
        <div className="absolute right-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" data-id="element-398"></div>

        <div className="flex gap-4 w-max animate-scroll px-4" data-id="element-399">
          {duplicatedTestimonials.map((testimonial, index) => <div key={`${testimonial.id}-${index}`} className="bg-white rounded-xl p-7 shadow-sm border border-gray-100 min-w-[330px] max-w-[360px] flex flex-col h-full" data-id="element-400">
              <div className="flex text-[#00E676] mb-4" data-id="element-401">
                {[1, 2, 3, 4].map(i => <Star key={i} className="w-4 h-4 fill-current" data-id="element-402" />)}
                {testimonial.rating === 5 ? <Star className="w-4 h-4 fill-current" data-id="element-403" /> : <div className="relative w-4 h-4" data-id="element-404">
                    <Star className="w-4 h-4 text-gray-200 fill-gray-200 absolute" data-id="element-405" />
                    <div className="overflow-hidden w-[50%] absolute h-full" data-id="element-406">
                      <Star className="w-4 h-4 fill-[#00E676] text-[#00E676]" data-id="element-407" />
                    </div>
                  </div>}
              </div>

              <p className="text-sm text-gray-600 mb-6 leading-relaxed flex-grow italic" data-id="element-408">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-gray-50" data-id="element-409">
                <div className="w-10 h-10 rounded-full bg-[#f0faf4] flex items-center justify-center text-[#00E676]" data-id="element-410">
                  <span className="text-sm font-bold" data-id="element-411">
                    {testimonial.initials}
                  </span>
                </div>
                <div data-id="element-412">
                  <p className="text-sm font-bold text-gray-900" data-id="element-413">
                    {testimonial.author}
                  </p>
                  <p className="text-[11px] text-gray-500 font-medium uppercase tracking-wider" data-id="element-414">
                    {testimonial.business}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-8" data-id="element-415">
        <div className="flex justify-center" data-id="element-416">
          <div className="inline-block bg-[#f0faf4] border border-[#00E676]/30 rounded-lg px-4 py-2" data-id="element-417">
            <p className="text-xs text-gray-700 font-semibold tracking-wide" data-id="element-418">
              Resultados reales, de personas reales ✨
            </p>
          </div>
        </div>
      </div>
    </section>;
}